var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createElement } from "react";
import createPurify from 'dompurify';
import parse, { domToReact } from 'html-react-parser';
import { useContent } from "../content";
import { RichEditor } from "../editor/rich-editor";
const purify = createPurify();
export const DisplayRichText = (_a) => {
    var { tagName = 'div', customElements = {} } = _a, props = __rest(_a, ["tagName", "customElements"]);
    const content = useContent();
    const html = purify.sanitize(content.value && content.value.__html || '');
    if (process.env.REACT_APP_CMS_NOADMIN || !content.editable) {
        const parseOpts = {
            replace: (node) => {
                const CustomElement = customElements[node.name];
                console.log(node.attribs);
                if (CustomElement) {
                    console.log(node);
                    return (React.createElement(CustomElement, Object.assign({}, node.attribs), domToReact(node.children, parseOpts)));
                }
            }
        };
        return createElement(tagName, props, parse(html, parseOpts));
    }
    return (React.createElement(RichEditor, Object.assign({}, props, { tagName: tagName, value: { __html: html }, onChange: content.onChange })));
};
//# sourceMappingURL=display-rich.js.map